import { styled } from '../../Utilities';
import { MarqueeSelectionBase } from './MarqueeSelection.base';
import { getStyles } from './MarqueeSelection.styles';
export var MarqueeSelection = styled(MarqueeSelectionBase, getStyles, undefined, {
    scope: 'MarqueeSelection'
});
//# sourceMappingURL=MarqueeSelection.js.map